import React from 'react';
import sdk from '../script/index';
import commons from '../script/utils/commons';
import '../style/warning.css';

export default class Auth extends React.Component {
    componentDidMount() {
        console.debug("PROPS:" + Object.keys(this.props) )

        let query = this.getRequestQuery(this.props.location);
        console.debug("Query:" + Object.keys(query) )

        // Clear any existing session
        commons.clearSession();

        sdk.login(query)
        .then(() => {
            commons.createSession(query);
            // BrowserRouter.push('/');
            this.redirectRoute('/');
            // <Redirect to="/" push={true}/>
        })
        .catch((err) => {
            //BrowserRouter.push('/unauthorised');
            console.error(err)
            this.redirectRoute('/unauthorised')
        });
    }


    render() {
        return (<div className="page-wrap">
            <div className="container">
                <div className="message animated bounceIn">
                    <div className="display-table">
                        <div className="display-table-cell">
                            <h2>logging in...</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }



    getRequestQuery(location){
        if (!location){
            return;
        }

        if (location.query){
            return location.query;
        }

        if (location.search.startsWith('?')){
            let params = location.search.substr(1);
            let query = {}
            params.split('&').forEach(x => {let kp = x.split('='); query[kp[0]]=kp[1]; })
            return query;
        }
    }


    redirectRoute(location) {
        if (this.props.history){
            this.props.history.push(location)
        }else {
            console.error("No history available to redirect to route location: " + location);
        }
    }
}



// WEBPACK FOOTER //
// ./src/route/Auth.js